import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const BoxShipmentIcon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", width: sizePx, height: sizePx, style: styles, ...rest },
        React.createElement("g", { clipPath: "url(#clip0_475_3877)" },
            React.createElement("path", { d: "M7 19L1 17.3571V10L7 11.6429V19Z", stroke: color, strokeWidth: "2", strokeLinejoin: "round" }),
            React.createElement("path", { d: "M13 12V10L7 11.6429V19L13 17.3571V16", stroke: color, strokeWidth: "2", strokeLinejoin: "round" }),
            React.createElement("path", { d: "M1 10L7.02192 8L13 10", stroke: color, strokeWidth: "2", strokeLinejoin: "round" }),
            React.createElement("path", { d: "M10 4H13C15.7614 4 18 6.23858 18 9C18 11.7614 15.7614 14 13 14H11", stroke: color, strokeWidth: "2" }),
            React.createElement("path", { d: "M12 1L9 4L12 7", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_475_3877" },
                React.createElement("rect", { width: "20", height: "20", fill: "white" })))));
};
export default BoxShipmentIcon;
//# sourceMappingURL=index.js.map